import { AccountReducer as account } from '@cms/tpl';
import { combineReducers } from 'redux';

const rootReducer = combineReducers({
  account,
});

export default rootReducer;
